import React, { FC, ReactNode, RefObject, useCallback } from 'react';
import StateManager from 'react-select';
import styled from 'styled-components';
import { FieldOptionBase } from 'api/tasks';
import { SingleSelectField } from 'components/organisms/tasks/fields';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { FieldHelper } from 'utils/field';
import { Popover, Select } from '../components/components';

type Props = ClassNameOnlyProps & {
  field: SingleSelectField;
  title: ReactNode;
  onChange: (latest: number | null) => void;
  selectRef: RefObject<StateManager>;
  isLoading?: boolean;
};

const StyledPopover = styled(Popover)`
  height: 448px;
`;

export const ControlledSingleSelectFieldEditorPopover: FC<Props> = ({
  field,
  title,
  onChange,
  selectRef,
  className,
  isLoading,
}) => {
  const onValueChange = useCallback(
    (latest: FieldOptionBase) => onChange(latest?.value ?? null),
    [onChange],
  );

  const {
    options: { activeOptions, allOptions },
  } = FieldHelper(field);

  return (
    <StyledPopover className={className}>
      <Popover.Title>{title}</Popover.Title>
      <Select
        ref={selectRef}
        type="tag"
        options={activeOptions}
        value={
          field?.value == null
            ? null
            : allOptions.find((x) => x.value === field?.value)
        }
        onChange={onValueChange}
        components={{
          LoadingIndicator: null,
        }}
        isLoading={isLoading}
      />
    </StyledPopover>
  );
};
